import { useEffect } from 'react'

/**
 * Hook to update the page title on route change
 */

export function usePageTitle(
  title: string,
  options?: { preserveOnUnmount?: boolean }
) {
  useEffect(() => {
    document.title = `Fundsorter - ${title}`
    // cleanup on unmount
    return () => {
      if (!options?.preserveOnUnmount) {
        document.title = 'Fundsorter'
      }
    }
  }, [title, options?.preserveOnUnmount])
}
